import { render, staticRenderFns } from "./home.vue?vue&type=template&id=035f8867&scoped=true"
import script from "./home.vue?vue&type=script&lang=js"
export * from "./home.vue?vue&type=script&lang=js"
import style0 from "./home.vue?vue&type=style&index=0&id=035f8867&prod&scoped=true&lang=css"
import style1 from "./home.vue?vue&type=style&index=1&id=035f8867&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "035f8867",
  null
  
)

export default component.exports